var ko = require('knockout');

function FilterViewModel(name, key, isActive) {
    var self = this;

    self.name = ko.observable(name);
    self.key = ko.observable(key);
    self.isActive = ko.observable(!!isActive);

    self.toggle = function () {
        self.isActive(!self.isActive());
    };
}

module.exports = FilterViewModel;